// Psychologist/PsychologistItem.tsx

import React, {useContext} from 'react';
import {IconButton} from '@mui/material';
import UserAvatar from 'User/UserAvatar';
import ChatIcon from '@mui/icons-material/Chat';
import {axios} from 'Auth/axiosConfig';
import {useNavigate} from 'react-router-dom';
import {AuthContext, AuthContextType} from 'Auth/AuthContext';
import {useErrorProcessing} from 'Core/components/ErrorProvider';
import {IPsychologist} from '../../Types/psychology/psychologist';
import {FCCC, FCSC, FRCC} from 'WideLayout/Layouts';
import {useTheme} from 'Theme/ThemeContext';
import FavoriteIcon from '@mui/icons-material/Favorite';
import {FavoritesContext} from "Psychologist/Favorites/FavoritesContext";

interface PsychologistItemProps {
    psychologist: IPsychologist;
    onClick?: () => void;
    isActive?: boolean;
    showChatButton?: boolean;
    showName?: boolean;
    sizeRem?: number;
    chatButtonSize?: string;
}

const PsychologistItem: React.FC<PsychologistItemProps> = (
    {
        sizeRem = 4,
        psychologist,
        onClick,
        isActive,
        showChatButton = false,
        chatButtonSize = '1rem',
        showName = true
    }) => {
    const {byResponse} = useErrorProcessing();
    const navigate = useNavigate();
    const {user} = useContext(AuthContext) as AuthContextType;
    const {plt} = useTheme();
    // const isMdOrSmaller = useMediaQuery(theme.breakpoints.down('md'));
    const {isFavorite} = useContext(FavoritesContext);
    const isFavoritePsychologist = isFavorite(psychologist.id);

    const handleChatClick = async (event: React.MouseEvent) => {
        if (!user) return;
        event.stopPropagation();
        try {
            const response = await axios.post('/api/v1/psych_client_init_room/', {
                name: `${user.id}-${psychologist.user.id}`,
                participants: [user.id, psychologist.user.id]
            });
            navigate(`/chats/room/${response.data.id}`);
        } catch (error) {
            byResponse(error);
        }
    };

    return (
        <FCCC pos={'relative'} g={1} lh={'1.1rem'} marginX={1}
              cls={'ftrans-300-eio'}
              maxW={isActive ? `${sizeRem + sizeRem * 0.1}rem` : `${sizeRem}rem`}
              onClick={onClick}
              sx={{
                  filter: isActive ? 'none' : 'grayscale(.1)',
              }}>
            {/* Отображение иконки избранного только если психолог в избранном */}
            {isFavoritePsychologist && (
                <FRCC pos={'absolute'} zIndex={10} cls={'top-0 right-0 p-0.5'}>
                    <FavoriteIcon color="error" fontSize="small"/>
                </FRCC>
            )}
            {(user?.is_staff) ?
                <FCCC pos={'absolute'} zIndex={10} left={0} top={0}>
                    <span>{psychologist.total_points}</span>
                </FCCC>
                : ''
            }

            <UserAvatar
                size={isActive ? `${sizeRem + sizeRem * 0.1}rem` : `${sizeRem}rem`}
                avatar={psychologist.user.avatar}
            />
            {showName &&
                <FCSC px={1} cls={'fs-6 ftrans-200-eio'}
                      style={{
                          color: isActive
                              ? plt.colors.secondary.main
                              : plt.text.primary80,
                          fontWeight: isActive
                              ? 'bold'
                              : 'unset',
                      }}>
                    <span>{psychologist.user.first_name}</span>
                    {/*<span>{psychologist.user.last_name}</span>*/}
                </FCSC>}
            {/* Отображение кнопки чата, если showChatButton = true */}
            {showChatButton && (
                <IconButton
                    onClick={(e) => {
                        e.stopPropagation(); // Предотвращение срабатывания onClick родителя
                        handleChatClick(e).then();
                    }}
                    style={{
                        zIndex: 10,
                        position: 'absolute',
                        bottom: showName ? '20px' : -6,
                        right: '-5px',
                        backgroundColor: plt.bg.primary30,
                        backdropFilter: 'blur(10px)',
                        padding: '6px 5px 5px 6px',
                    }}
                >
                    <ChatIcon style={{fontSize: chatButtonSize}}/>
                </IconButton>
            )}
        </FCCC>
    );
};

export default PsychologistItem;
